var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cta",on:{"click":_vm.clickHandler}},[(_vm.icon)?_c('i',{staticClass:"cta__icon",class:_vm.processing ? 'fas fa-spin fa-spinner' : _vm.icon}):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }